<div class="mb-checkout-quote-info" data-cy="mb-checkout-quote-info">

  <div class="row no-gutters">
    <div class="col-12 text-center">
      <img src="./assets/icons/svg/Icon_checklist.svg"
           title="Quote Page Icon"
           alt="Quote Page Icon"/>
    </div>

    <div class="col-12 my-4 text-center mb-checkout-quote-info-headline">
      <span>{{ 'quoteInfo.headline' | cxTranslate }}</span>
    </div>

    <div class="col-12 mt-3 mb-4 text-center mb-checkout-quote-info-text">
      <span>{{ 'quoteInfo.whatsNext' | cxTranslate }}</span>
    </div>

    <div class="col-12">
      <div class="row no-gutters">
        <div class="col-4 col-sm-3 col-md-2 pl-0 pl-md-4">
          <img src="./assets/icons/svg/icon_1.svg"
               class="mb-5 mb-checkout-quote-info-icons"
               title="Request Process Step 1"
               alt="Request Process Step 1"/>
          <div class="progress-bar-connector"></div>
        </div>
        <div class="col-8 col-sm-9 col-md-10 pl-0 pl-md-4 my-auto">
          <div class="mb-5 mb-checkout-quote-info-text">{{ 'quoteInfo.step1' | cxTranslate }}</div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-4 col-sm-3 col-md-2 pl-0 pl-md-4">
          <img src="./assets/icons/svg/icon_2.svg"
               class="mb-5 mb-checkout-quote-info-icons"
               title="Request Process Step 2"
               alt="Request Process Step 2"/>
          <div class="progress-bar-connector elongate"></div>
        </div>
        <div class="col-8 col-sm-9 col-md-10 pl-0 pl-md-4 my-auto">
          <div class="mb-5 mb-checkout-quote-info-text">{{ 'quoteInfo.step2' | cxTranslate }}</div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-4 col-sm-3 col-md-2 pl-0 pl-md-4">
          <img src="./assets/icons/svg/icon_3.svg"
               class="mb-5 mb-checkout-quote-info-icons"
               title="Request Process Step 3"
               alt="Request Process Step 3"/>
        </div>
        <div class="col-8 col-sm-9 col-md-10 pl-0 pl-md-4 my-auto">
          <div class="mb-5 mb-checkout-quote-info-text">{{ 'quoteInfo.step3' | cxTranslate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="(isTypeA$ | async)"
       class="row no-gutters mb-5">
    <div class="col-12 col-sm-7 mx-auto mb-4 text-center mb-checkout-quote-info-text">
      {{ 'quoteInfo.selectCountry' | cxTranslate }}
    </div>

    <div class="col-12 col-sm-7 mx-auto field-wrapper text-center"
         mbFloatingLabel>
      <label for="country"
             class="mandatory-input-asterisk mb-checkout-quote-country-selection-label mb-custom-label">{{ 'mbcommon.country' | cxTranslate}}</label>
      <input class="w-100 mb-form-input"
             id="country"
             name="country"
             data-cy="mb-checkout-quote-country-selection"
             type="text"
             [(ngModel)]="selectedCountryName"
             [value]="selectedCountry?.name"
             [ngbTypeahead]="search"
             [editable]="false"
             (selectItem)="onCountrySelectionHandler($event?.item)"
             (focus)="onFocus($event)"
             (blur)="updatedSelectedCountryOnBlur()"/>
    </div>
  </div>

  <div class="row no-gutters">
    <div class="col-12 col-md mr-4 mt-2 order-2 order-md-1">
      <button class="btn btn-block btn-secondary mb-buttons"
              data-cy="mb-checkout-quote-info-back-btn"
              type="button"
              (click)="back()">
        {{ 'navigationPage.backBtn' | cxTranslate }}
      </button>
    </div>
    <div class="col-12 col-md mt-2 order-1 order-md-2">
      <button class="btn btn-block btn-primary mb-buttons"
              data-cy="mb-checkout-quote-info-next-btn"
              type="button"
              mbOneClickAllowed
              (click)="next()">
        {{ 'navigationPage.nextBtn' | cxTranslate }}
      </button>
    </div>
  </div>
</div>
